export default {
  surveyReply: {
    default: 'Enquêtes de satisfaction',
    list: {
      page_title: 'Liste des enquêtes',
      date: 'Date de réponse',
      company: 'Société'
    },
    edit: {
      page_title: 'Modification de l\'enquête :'
    },
    show: {
      page_title: 'Fiche de l\'enquête :',
      date: 'Date de réponse',
      response: 'Réponse'
    },
    create: {
      page_title: 'Enquête de satisfaction - création'
    },
    notif: 'Questionnaire de satisfaction en attente',
    alert: {
      success: 'Votre réponse a bien été envoyée.',
      successPublic: 'Votre réponse a bien été envoyée. Merci d\'avoir participé à notre enquête de satisfaction',
      failure: "Un problème est survenu. Votre réponse n'a pas été prise en compte."
    },
    error: {
      unavailable: "Aucune enquête n'est disponible actuellement"
    }
  },
  surveyQuestion: {
    default: 'Questions enquête utilisateur',
    list: {
      page_title: 'Liste des questions',
      field_type: 'Type'
    },
    edit: {
      page_title: "Edition d'une question"
    },
    create: {
      page_title: "Création d'une question"
    }
  },
  surveyQuestionTraveller: {
    default: 'Questions enquête voyageur',
    list: {
      page_title: 'Liste des questions voyageur',
      field_type: 'Type'
    },
    edit: {
      page_title: "Edition d'une question voyageur"
    },
    create: {
      page_title: "Création d'une question voyageur"
    }
  }
}
